// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__jjVAm5cC","loader":"Loader_loader__i5rwBAzG","loaderAnimation":"Loader_loaderAnimation__9lgG8xCR"};